import { ArrowRight } from 'lucide-react';

import { PrimaryCTA } from '../../components/PrimaryCTA';
import { SectionWrapper } from '../../components/SectionWrapper';

import styles from './HumanitiesContactCTASection.module.css';

export function HumanitiesContactCTASection() {
  return (
    <SectionWrapper background="navy" data-testid="humanities-section-contact">
      <div className={styles.section}>
        <h2 className={styles.title}>Bring Kudu Humanities to your course.</h2>
        <p className={styles.subhead}>
          We partner with faculty and institutions to design AI-integrated
          humanities courses that keep intellectual rigor and human mentorship at
          the center.
        </p>
        <PrimaryCTA
          className={styles.cta}
          href="/contact"
          icon={<ArrowRight aria-hidden="true" size={16} />}
          label="Get in touch"
        />
        <p className={styles.note}>
          Or email <a href="mailto:support@kudu.com">support@kudu.com</a>
        </p>
      </div>
    </SectionWrapper>
  );
}
